import { AvailableCampaigns, TargetTypes } from 'entities/Config'
import keyValuePath from 'utils/keyValuePath'
import { getActiveCampaignFromStorage } from 'utils/sessionStorage'
import { UrlGetParams } from 'consts'
import isRecommendedProduct from 'utils/isRecommendedProduct'
import type {
  TargetingDatalayer,
  TargetingQuerystring,
  TargetType,
  ThemeConfig,
  ThemesListConfig,
} from 'entities/Config'

const getTheme = (themes: ThemesListConfig): ThemeConfig => {
  const themeConfigEntries = Object.values(themes)
  const defaultTheme: ThemeConfig = themes[AvailableCampaigns.default]

  const urlParams = new URLSearchParams(window?.location?.search || '')

  if (urlParams.has(UrlGetParams.SupportChat)) {
    return defaultTheme
  }

  if (isRecommendedProduct(urlParams)) {
    const activeCampaign = getActiveCampaignFromStorage()

    const campaignId = activeCampaign.id
    return (
      themeConfigEntries.find(
        (config: ThemeConfig) => config.id === campaignId
      ) || defaultTheme
    )
  }

  return (
    themeConfigEntries.find((config: ThemeConfig) => {
      if (config?.targeting) {
        return config.targeting.some((target: TargetType) => {
          if (
            target.type === TargetTypes.datalayer &&
            window?.dataLayer?.length
          ) {
            const { dataLayer } = window
            let dataLayerPath: string | undefined
            for (let i = dataLayer.length - 1; i >= 0; i -= 1) {
              dataLayerPath = keyValuePath(
                dataLayer[i],
                (target as TargetingDatalayer).path
              )

              if (dataLayerPath) break
            }

            return dataLayerPath === target.value
          }

          if (target.type === TargetTypes.querystring) {
            const params = new URLSearchParams(window.location.search)

            return (
              params.get((target as TargetingQuerystring).key) === target.value
            )
          }

          if (target.type === TargetTypes.pathname) {
            return target.value === window.location.pathname
          }

          return false
        })
      }

      return false
    }) || defaultTheme
  )
}

export default getTheme
